module.exports = __webpack_public_path__ + "assets/img/33_1577_big.e0284199.jpg";